Cm.search = {
    state: 0,
    value: '',
    timer: null,
    $el: null,
    active: -1,
    hasPost: false,
    totalPost: 0,
    template: function() {
        return `<a href="__URL__" class="list-group-item list-group-item-action">
                <p class="tname">__NAME__</p>
                <small><em>__TYPE__</em></small>
            </a>`;
    },
    init() {
        const _this = this;
        this.$el = $('.header-search-result');

        $('body').on('focus', '.header-search-form .search-input', function() {
            Cm.search.value = this.value;
            Cm.search.state = 0;
            _this.display();
        });

        $('body').on('click', function(e) {
            var isSearch = $(e.target).closest('.header-search-form');

            if (! isSearch || !isSearch.length) {
                _this.remove();
            }
        });

        $('body').on('keyup keydown input', '.header-search-form .search-input', function(e) {
            if (Cm.search.timer) clearTimeout(Cm.search.timer);

            var _e = $(this);
            var _key = e || window.event;

            if (_key.keyCode != '38' && _key.keyCode != '40' && _key.keyCode != '37' && _key.keyCode != '39' && _key.keyCode != '13') {
                Cm.search.timer = setTimeout(function() {
                    Cm.search.value = _e.val();
                    Cm.search.state = 1;
                    _this.display();
                }, 550);
            } else {
                Cm.search.timer = setTimeout(function() {
                    if (_key.keyCode == '38' && Cm.search.hasPost) { // up, --
                        if (Cm.search.active <= 0) {
                            Cm.search.active = Cm.search.totalPost - 1;
                        } else {
                            Cm.search.active--;
                        }

                        _this.setActive();
                    } else if (_key.keyCode == '40' && Cm.search.hasPost) { // down
                        if (Cm.search.active >= Cm.search.totalPost - 1) {
                            Cm.search.active = 0;
                        } else {
                            Cm.search.active++;
                        }

                        _this.setActive();
                    }
                }, 150);

                if (_key.keyCode == '38' || _key.keyCode == '40') { return false; }

                if (_key.keyCode == '13') {
                    _this.openLink();
                }
            }
        });
    },
    display() {
        if (Cm.search.value == '') {
            this.$el.find('.list-group').addClass('d-none');
            this.$el.find('.search-hint-text').text(this.$el.find('.search-hint-text').data('default')).removeClass('d-none');
        }

        if (Cm.search.state && Cm.search.value != '') {
            this.$el.find('.list-group').addClass('d-none');
            this.$el.find('.search-hint-text').text(this.$el.find('.search-hint-text').data('search')).removeClass('d-none');

            Cm.search.hasPost = false;
            Cm.search.active = -1;
            Cm.search.totalPost = 0;
            this.search();
        }

        this.$el.removeClass('d-none');
    },
    search() {
        var _this = this;
        Cm.forms.post({
            data: {
                action: 'search_website_content',
                search: this.value,
            },
            success: function(response) {
                var list = '';
                if (response && response.length) {
                    for (let i = 0; i < response.length; i++) {
                        var post = response[i];
                        list += _this.template()
                            .replace('__URL__', post.url)
                            .replace('__NAME__', post.title)
                            .replace('__TYPE__', post.type);
                    }

                    _this.$el.find('.list-group').html(list).removeClass('d-none');
                    _this.$el.find('.search-hint-text').addClass('d-none');
                    
                    Cm.search.hasPost = true;
                    Cm.search.totalPost = response.length;
                } else {
                    _this.$el.find('.search-hint-text').text(_this.$el.find('.search-hint-text').data('empty'));
                }
            },
            fail: function() {
                _this.$el.find('.search-hint-text').text(_this.$el.find('.search-hint-text').data('error'));
            }
        });
    },
    setActive() {
        this.$el.find('.list-group').find('a').removeClass('active-item');
        this.$el.find('.list-group').find('a').eq(this.active).addClass('active-item');
    },
    openLink() {
        if (this.hasPost && this.active > -1) {
            var url = this.$el.find('.list-group').find('a').eq(this.active).attr('href');
            window.location.href = url;
        }
    },
    remove() {
        this.$el.addClass('d-none');
    }
};